import { render, staticRenderFns } from "./SelectedInvoicesSum.vue?vue&type=template&id=bc537ca8&"
import script from "./SelectedInvoicesSum.vue?vue&type=script&lang=js&"
export * from "./SelectedInvoicesSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports